// src/data/initialDonations.ts
export const INITIAL_DATA_VERSION = 1;

export const initialTopDonations = [
  { name: 'Àlex M.', amount: 50.0 },
  { name: 'Maria G.', amount: 35.0 },
  { name: 'Carles P.', amount: 25.0 },
  { name: 'Laura S.', amount: 20.0 },
  { name: 'Joan R.', amount: 15.0 },
];

export const initialRecentDonations = [
  { name: 'Martí V.', amount: 8.0, date: '2025-01-15' },
  { name: 'Anna L.', amount: 12.0, date: '2025-01-14' },
  { name: 'David M.', amount: 5.0, date: '2025-01-13' },
  { name: 'Núria P.', amount: 15.0, date: '2025-01-12' },
  { name: 'Marc R.', amount: 3.0, date: '2025-01-11' },
];
